export const ERROR_CODES = [
    'EMAIL_TAKEN',
    'INVALID_CREDENTIALS',
    'UNAUTHORIZED',
    'FORBIDDEN',
    // Sign-in blocked because the account was deactivated (soft-deleted).
    'ACCOUNT_DEACTIVATED',
    'VALIDATION_FAILED',
    'INVITE_INVALID',
    'INVITE_EXPIRED',
    'INVITE_USED',
    // Booking: the requested slot is already taken (double-booking guard).
    'SLOT_TAKEN',
    // Booking: the requested slot is in the past — past slots are locked.
    'SLOT_IN_PAST',
    // Voice-agent (ElevenLabs) provider codes.
    'AGENT_NOT_CONFIGURED',
    'AGENT_ALREADY_SYNCED',
    'AGENT_NOT_SYNCED',
    'AGENT_REQUEST_FAILED',
    'FAQ_EMPTY',
    'DOCUMENT_EMPTY',
    'GOOGLE_NOT_CONFIGURED',
    'GOOGLE_OAUTH_FAILED',
    'GOOGLE_INVALID_STATE',
    'GOOGLE_NOT_CONNECTED',
    // Remote calendar (Superdoc / common Calendar API) request failure.
    'HEALEE_REQUEST_FAILED',
    // In-app assistant (Claude) codes.
    'ASSISTANT_NOT_CONFIGURED',
    'ASSISTANT_REQUEST_FAILED',
    // Admin JSON data import (export/import feature).
    'IMPORT_FAILED',
    'UNKNOWN_ERROR',
];
/** Wire-level separator embedded in `.message` so the client can split a code
 *  from human-readable detail without a custom response shape. ZenStack RPC
 *  only forwards `Error.message`; carrying both code and detail in one string
 *  lets us surface upstream errors (e.g. the provider's rejection reason) in the UI
 *  without server middleware. */
export const CODED_ERROR_DETAIL_SEP = ' :: ';
export class CodedError extends Error {
    code;
    statusCode;
    detail;
    meta;
    constructor(code, statusCode = 400, meta, detail) {
        super(detail ? `${code}${CODED_ERROR_DETAIL_SEP}${detail}` : code);
        this.name = 'CodedError';
        this.code = code;
        this.statusCode = statusCode;
        this.meta = meta;
        this.detail = detail;
    }
}
export function isCodedErrorBody(value) {
    if (!value || typeof value !== 'object')
        return false;
    const code = value.code;
    return typeof code === 'string' && ERROR_CODES.includes(code);
}
